import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getTransaction = ({ tx_ref }) => {
  return axios.get(`/transaction/${tx_ref}`);
};

export const useTransaction = ({ tx_ref, config }) => {
  return useQuery({
    ...config,
    queryKey: ['transaction', tx_ref],
    queryFn: () => getTransaction({ tx_ref }),
  });
};
